@switch (timeline_item.card_type) {
    @case ('standalone_array') {
        <app-standlone-array
            [card]="timeline_item"
            [attr.data-card-id]="timeline_item.context.uuid"
            [timeline_id]="timeline_id"
            [aspect_ratio]="timeline_item.context.aspect_ratio"
        ></app-standlone-array>
    }

    @case ('enhanced_article_subject') {
        <app-contributed-articles-card [card]="timeline_item" [attr.data-card-id]="timeline_item.context.uuid" [timeline_id]="timeline_id"></app-contributed-articles-card>
    }

    @case ('enhanced_article') {
        <app-contributed-articles-card [card]="timeline_item" [attr.data-card-id]="timeline_item.context.uuid" [timeline_id]="timeline_id"></app-contributed-articles-card>
    }

    @case ('contributed_article') {
        <app-contributed-articles-card [card]="timeline_item" [attr.data-card-id]="timeline_item.context.uuid" [timeline_id]="timeline_id"></app-contributed-articles-card>
    }

    @case ('my_followed_tennis_players') {
        <app-follow-players-card [card]="timeline_item" [attr.data-card-id]="timeline_item.context.uuid"></app-follow-players-card>
    }

    @case ('combined_social') {
        <app-combined-social-card [card]="timeline_item" [attr.data-card-id]="timeline_item.context.uuid"></app-combined-social-card>
    }

    @case ('sponsor_placeholder') {
        @if (timeline_item && timeline_item.context.uuid) {
            @if (video_ad_sponsor) {
                <app-rotating-sponsors
                    [video_ad_sponsor]="video_ad_sponsor"
                    [card]="timeline_item"
                    [attr.data-card-id]="timeline_item.context.uuid"
                    [default_aspect_ratio]="timeline_item.context.aspect_ratio"
                ></app-rotating-sponsors>
            } @else if (!video_ad_sponsor) {
                <app-rotating-sponsors [card]="timeline_item" [attr.data-card-id]="timeline_item.context.uuid"></app-rotating-sponsors>
            }
        }
    }

    @case ('feed_item') {
        <app-social-feed-card [card]="timeline_item" [attr.data-card-id]="timeline_item.context.uuid" [timeline_id]="timeline_id"></app-social-feed-card>
    }

    @case ('feed_subject') {
        <app-feed-subject-card [card]="timeline_item" [attr.data-card-id]="timeline_item.context.uuid" [timeline_id]="timeline_id"></app-feed-subject-card>
    }

    @case ('sponsor') {
        <app-sponsor-banner [sponsor_key]="timeline_item.data[0].key!" [aspect_ratio]="aspect_ratio"></app-sponsor-banner>
    }
}
